type ApiResponse = ApiSuccess | ApiError;

export interface ApiSuccess {
    [key: string]: string;
}

export interface ApiError {
    [key: string]: string[];
}

const send = async (formData: FormData, url: string): Promise<ApiResponse> => {
    return new Promise<ApiResponse>((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader("X-Requested-With", 'XMLHttpRequest');
        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                try {
                    const response = JSON.parse(xhr.responseText);
                    if (xhr.status === 200 || xhr.status === 201) {
                        resolve(response as ApiSuccess);
                    } else {
                        reject(response as ApiError);
                    }
                    // @ts-ignore
                } catch (error: Error) {
                    if (error instanceof SyntaxError) {
                        console.error('Retour serveur non conforme JSON');
                    } else {
                        console.error(error);
                    }
                    reject({error: error.message} as ApiError);
                }
            }
        };
        xhr.send(formData);
    });
};

export { send };
